import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { environmentURL } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RealtimeService {
  private hubConnection: signalR.HubConnection;

  constructor() {
    const apiUrl = environmentURL.apiURL + 'announcementNotifyHub';
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(apiUrl)
      .withAutomaticReconnect()
      .build();
  }

  get connection(): signalR.HubConnection {
    return this.hubConnection;
  }

  on(eventName: string, callback: (...args: any[]) => void): void {
    this.hubConnection.on(eventName, callback);
  }

  off(eventName: string, callback: (...args: any[]) => void): void {
    this.hubConnection.off(eventName, callback);
  }
}
